// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2pZS-","bigColWidth":"Table_bigColWidth__2gq6B","biggerColWidth":"Table_biggerColWidth__1kvVr","row":"Table_row__2nkaA","col":"Table_col__1AULX"};